var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-table__row final-score table-total"},[_vm._l((_vm.dataProps),function(cell,cellIndex){return [_c('div',{staticClass:"app-table__cell",class:[
            cell.prop,
            cell.propType,
            {'number': ['totalSum',].includes(cell.prop)}
         ]},[_c('div',{staticClass:"app-table__cell-content",domProps:{"innerHTML":_vm._s(cell.usePrintedValue ? _vm.total[`${cell.prop}Printed`] : _vm.total[cell.prop])}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }